import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AddRecord, AddRecords, SetRecordsError, SetRecordsLoading } from '@actions/records.actions';
import { getRecord, getRecords, recordsErrorSelector, recordsLoadingSelector } from '@state/selectors/records.selector';
import { PortalState } from '@state/state';

import { AbstractRecordsStateService, ApiFragment, FragmentId } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class PortalStoreRecordsStateService implements AbstractRecordsStateService {
    constructor(private store: Store<PortalState>) {}

    public getRecordsError(): Observable<boolean> {
        return this.store.select(recordsErrorSelector);
    }

    public setRecordsError(error: boolean): void {
        return this.store.dispatch(new SetRecordsError(error));
    }

    public getRecordsLoading(): Observable<boolean> {
        return this.store.select(recordsLoadingSelector);
    }

    public setRecordsLoading(loading: boolean): void {
        return this.store.dispatch(new SetRecordsLoading(loading));
    }

    public getRecords(ids: FragmentId[]): Observable<(ApiFragment | undefined)[]> {
        return this.store.select(getRecords(ids));
    }

    public getDefinedRecords(ids: FragmentId[]): Observable<ApiFragment[]> {
        return this.getRecords(ids).pipe(
            map(entries => entries.filter((entry): entry is ApiFragment => typeof entry !== 'undefined'))
        );
    }

    public addRecords(records: ApiFragment[]): void {
        return this.store.dispatch(new AddRecords(records));
    }

    public getRecord(id: FragmentId): Observable<ApiFragment | undefined> {
        return this.store.select(getRecord(id));
    }

    public addRecord(record: ApiFragment): void {
        return this.store.dispatch(new AddRecord(record));
    }
}
